import {motion} from "framer-motion";
import PyramidChart from "./chart/chart1";
import {useState} from "react";
import CountUp from "react-countup";
import PieChart from "./chart/chart2";
import PyramidChart2 from "./chart/chart4";

export const Charts = () => {
    const [showChart, setShowChart] = useState(false);
    const [startCount, setStartCount] = useState(false);

    return (
        <div className='row cBorder7 cMarginTop1 cPx1 justify-content-center position-relative'>
            <div className="position-absolute d-none d-lg-flex cShadow1 cShadow2 justify-content-center align-items-center"></div>
            <div className="position-absolute d-none d-lg-flex cShadow1 cShadow3 justify-content-center align-items-center"></div>

            <div className='cContainer col-12'>
                <div className='row'>

                    <div className='col-12 text-center'>
                            <h2 className='text-center cFontSize30_res cFontSize30 fw-bold'>
                                وضعیت طرح‌ها
                            </h2>

                            <p className="mb-0 mt-3 lh-lg cFontSize16 cFontSize16_res cTextJustify m-auto cColor4">
                                مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی
                            </p>
                    </div>

                    <div className="col-12 col-lg-10 mb-3 offset-lg-1 text-center cMinHeight2">

                        <motion.div
                            className='d-lg-none'
                            viewport={{
                                once: true,
                                amount: 0.8,
                                margin: "0px 0px -100px 0px"
                            }}
                            onViewportEnter={() => setShowChart(true)}
                        >
                            {showChart && <PyramidChart2/>}
                        </motion.div>
                         <motion.div
                             className='d-none d-lg-block'
                            viewport={{
                                once: true,
                                amount: 0.8,
                                margin: "0px 0px -250px 0px"
                            }}
                            onViewportEnter={() => setShowChart(true)}
                        >
                            {showChart && <PyramidChart/>}
                        </motion.div>
                    </div>

                    <div className='col-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-end'>
                        <motion.div
                            className='d-lg-none'
                            viewport={{once: true, amount: 0.1, margin: "0px 0px -100px 0px"}}
                            onViewportEnter={() => setStartCount(true)}
                        >

                            <div className='row justify-content-center'>

                                <div className='col-auto text-center my-3 my-lg-0 cBorder3'>
                                    <div className="card-client">
                                        <div className="user-picture">
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                        </div>
                                        <p className="name-client fw-bold"> پژوهشگران
                                        </p>
                                        <div className="social-media">
                                             <h2 className='fw-bold cColor3'>
                                        {startCount && (
                                            <CountUp
                                                start={0}
                                                end={3784}
                                                duration={2}
                                                separator=","
                                            />
                                        )}
                                    </h2>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-auto text-center my-3 my-lg-0'>
                                    <div className="card-client">
                                        <div className="user-picture">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                        </div>
                                        <p className="name-client fw-bold"> داوران
                                        </p>
                                        <div className="social-media">
                                            <h2 className='fw-bold cColor3'>
                                                {startCount && (
                                                    <CountUp
                                                        start={0}
                                                        end={1264}
                                                        duration={2}
                                                        separator=","
                                                    />
                                                )}
                                            </h2>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </motion.div>
                        <motion.div
                            className='d-none d-lg-block'
                            viewport={{once: true, amount: 0.1, margin: "0px 0px -150px 0px"}}
                            onViewportEnter={() => setStartCount(true)}
                        >

                            <div className='row justify-content-center'>

                                <div className='col-auto text-center my-3 my-lg-0 cBorder3'>
                                    <div className="card-client">
                                        <div className="user-picture">
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                        </div>
                                        <p className="name-client fw-bold"> پژوهشگران
                                        </p>
                                        <div className="social-media">
                                             <h2 className='fw-bold cColor3'>
                                        {startCount && (
                                            <CountUp
                                                start={0}
                                                end={3784}
                                                duration={2}
                                                separator=","
                                            />
                                        )}
                                    </h2>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-auto text-center my-3 my-lg-0'>
                                    <div className="card-client">
                                        <div className="user-picture">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0"/>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 fill="currentColor"
                                                 className="bi bi-person-standing-dress cColor3"
                                                 viewBox="0 0 16 16">
                                                <path
                                                    d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"/>
                                            </svg>
                                        </div>
                                        <p className="name-client fw-bold"> داوران
                                        </p>
                                        <div className="social-media">
                                            <h2 className='fw-bold cColor3'>
                                                {startCount && (
                                                    <CountUp
                                                        start={0}
                                                        end={1264}
                                                        duration={2}
                                                        separator=","
                                                    />
                                                )}
                                            </h2>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </motion.div>
                    </div>

                    <div className='col-12 mt-4 mt-lg-0 col-lg-6'>
                            <PieChart/>
                    </div>

                </div>
            </div>
        </div>
    );
};